import { TODO } from '@b2b/types/core/utils';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { SettingsTerminalControllerModule } from './controllers/SettingsTerminalsController';

export const SettingsTerminalsView = angular
  .module('acme.view.application.settings.terminals', [uiRouter, 'ui.bootstrap', SettingsTerminalControllerModule])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const settingsTerminals = {
      name: 'application.settings.terminals',
      url: '/terminals',
      params: {
        terminalId: '',
      },
      views: {
        'subview-main': {
          controller: 'SettingsTerminalsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settings/terminals/terminals.tpl.html',
        },
      },
      resolve: {
        terminalId: [
          '$stateParams',
          function ($stateParams) {
            return $stateParams.terminalId || '';
          },
        ],
        CustomFieldsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: TODO, HelpersService) {
            return ApiService.customFields.list(HelpersService.getPaginator());
          },
        ],
      },
      data: {
        pageTitle: 'Terminals',
        permissions: ['POS_SALE_TERMINALS_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(settingsTerminals);
  }).name;
